import {
    // SET_REQUEST,
    // SET_SELECTED_SUBTYPE_ID,
    SET_SELECTED_BRANCH,
    SET_SELECTED_REQUISITION_TYPE,
    SET_IREQUEST,
    SET_INON_STANDARD_EQUIPMENT,
    SET_IPRODUCTION_VEHICLE,
    SET_IREASON,
    SET_CART_IREQUEST,
    SET_CART_IPRODUCTION_VEHICLE,
    SET_CART_IREASON,
    SET_SHOW_ITEM_DETAILS,
    SET_IS_ADD_TO_CART_CLICK,
    SET_IS_REASON_CHANGE,
    SET_IORDER_REQUEST,
    CREATE_ORDER_REQUEST,
    SET_ORDER_LEADR_NUMBER,
    SET_IS_ORDER_CREATION_SUCCESS,
    SET_IS_SUBMIT_CLICK,
    SET_IS_SAVE_CLICK,
    SET_ORDER_ID,
    SET_IS_EDIT_ORDER,
    SET_CART_INON_STANDARD_EQUIPMENT,
    SET_IMANAGED_EQUIPMENT,
    SET_CART_IMANAGED_EQUIPMENT,
    SET_MANAGED_EQUIPMENT_VALUES,
    SET_SELECTED_EQUIPMENT_TYPE,
    SET_CART_IMANAGEMENT_VEHICLE,
    SET_IMANAGEMENT_VEHICLE,
    SET_SELECTED_CATALOG_ITEM,
    SET_IS_CATALOG_ITEM_EXIST,
    SET_IS_CHANGES_OCCURED,
    SET_ISMAND_FLAG,
    SET_PRODUCTION_VEHICLE_DANGEROUSLY_SET_EXPANDED,
    SET_ORDER_EDIT_NAVIGATION_CHANGE,
    SET_IS_ADD_ASSET_CLICK,
    SET_IS_ADD_ITEM_CLICK,
    SET_EDIT_REQUEST_DETAILS,
    SET_IS_EDIT_REQUEST_CLICK,
    SET_IS_ADD_REQUISITION_TYPE_CLICK,
    SET_IS_UPDATE_SUCCESS_ALERT,
    SET_IS_APPROVAL_OVERRIDE_FLAG,
    SET_IS_DEALER_SAMEFORALL_FLAG
    
} from "./RequisitionType";



const setSelectedBranch = (selectedBranch: any) => ({
    type: SET_SELECTED_BRANCH,
    selectedBranch: selectedBranch
});

const setSelectedRequisitionType = (selectedRequisitionType: any) => ({
    type: SET_SELECTED_REQUISITION_TYPE,
    selectedRequisitionType: selectedRequisitionType
});

const setIRequest = (requestList: any) => {
    return {
        type: SET_IREQUEST,
        requestList: requestList,
    };
};

const setIManagementVehicle = (managementVehicleList: any) => {
    return {
        type: SET_IMANAGEMENT_VEHICLE,
        managementVehicleList: managementVehicleList,
    };
};

const setINonStandardEquipment = (nonStandardEquipmentList: any) => {
    return {
        type: SET_INON_STANDARD_EQUIPMENT,
        nonStandardEquipmentList: nonStandardEquipmentList,
    };
};

const setIProductionVehicle = (productionVehicleList: any) => {
    return {
        type: SET_IPRODUCTION_VEHICLE,
        productionVehicleList: productionVehicleList,
    };
};

const setIReason = (reasonList: any) => {
    return {
        type: SET_IREASON,
        reasonList: reasonList,
    };
};

const setCartIRequest = (requestList: any) => {
    return {
        type: SET_CART_IREQUEST,
        requestList: requestList,
    };
};

const setCartIProductionVehicle = (productionVehicleList: any) => {
    return {
        type: SET_CART_IPRODUCTION_VEHICLE,
        productionVehicleList: productionVehicleList,
    };
};

const setCartINonStandardEquipment = (nonStandardEquipmentList: any) => {
    return {
        type: SET_CART_INON_STANDARD_EQUIPMENT,
        nonStandardEquipmentList: nonStandardEquipmentList,
    };
};

const setCartIManagementVehicle = (managementVehicleList: any) => {
    return {
        type: SET_CART_IMANAGEMENT_VEHICLE,
        managementVehicleList: managementVehicleList,
    };
};

const setCartIReason = (reasonList: any) => {
    return {
        type: SET_CART_IREASON,
        reasonList: reasonList,
    };
};

const setShowItemDetails = (showItemDetails: any) => ({
    type: SET_SHOW_ITEM_DETAILS,
    showItemDetails: showItemDetails,
});

const setIsAddToCartClick = (isAddToCartClick: boolean) => ({
    type: SET_IS_ADD_TO_CART_CLICK,
    isAddToCartClick: isAddToCartClick,
});

const setIsReasonChange = (isReasonChange: boolean) => ({
    type: SET_IS_REASON_CHANGE,
    isReasonChange: isReasonChange,
});

// Store converted API Object
const setIOrderRequest = (orderRequest: any) => ({
    type: SET_IORDER_REQUEST,
    orderRequest: orderRequest
});

// Send Order Request to API
const createOrderRequest = (orderRequest: any) => ({
    type: CREATE_ORDER_REQUEST,
    orderRequest
});

const isSubmitClick = (isSubmitClick: boolean) => ({
    type: SET_IS_SUBMIT_CLICK,
    isSubmitClick
});

const isSaveClick = (isSaveClick: boolean) => ({
    type: SET_IS_SAVE_CLICK,
    isSaveClick
});

// Set leadr Number which is generated after order creation
const setOrderLeadrNumber = (leadrNumber: any) => ({
    type: SET_ORDER_LEADR_NUMBER,
    leadrNumber: leadrNumber
});

const setIsOrderCreationSuccess = (isOrderCreationSuccess: any) => ({
    type: SET_IS_ORDER_CREATION_SUCCESS,
    isOrderCreationSuccess: isOrderCreationSuccess
});

const setOrderId = (orderId: any) => ({
    type: SET_ORDER_ID,
    orderId: orderId
})

const setIsEditOrder = (isEditOrder: any) => ({
    type: SET_IS_EDIT_ORDER,
    isEditOrder: isEditOrder
})

const setIManagedEquipment = (managedEquipmentList: any) => {
    return {
        type: SET_IMANAGED_EQUIPMENT,
        managedEquipmentList: managedEquipmentList,
    };
};

const setCartIManagedEquipment = (managedEquipmentCartList: any) => {
    return {
        type: SET_CART_IMANAGED_EQUIPMENT,
        managedEquipmentCartList: managedEquipmentCartList,
    };
};

const setManagedEquipmentValues = (managedEquipmentValues: any) => {
    return {
        type: SET_MANAGED_EQUIPMENT_VALUES,
        managedEquipmentValues: managedEquipmentValues,
    };
};

const setSelectedEquipmentType = (selectedEquipmentType: any) => {
    return {
        type: SET_SELECTED_EQUIPMENT_TYPE,
        selectedEquipmentType: selectedEquipmentType,
    };
};

const setSelectedCatalogItem = (selectedCatalogItem: any) => {
    return {
        type: SET_SELECTED_CATALOG_ITEM,
        selectedCatalogItem: selectedCatalogItem,
    };
};

const setIsCatalogItemExist = (isCatalogItemExist: any) => {
    return {
        type: SET_IS_CATALOG_ITEM_EXIST,
        isCatalogItemExist: isCatalogItemExist,
    };
};

const setIsChangesOccured = (isChangesOccured: any) => {
    return {
        type: SET_IS_CHANGES_OCCURED,
        isChangesOccured: isChangesOccured,
    };
};

const setIsMandFlag = (IsMandAFlag: boolean) => {
    return {
        type: SET_ISMAND_FLAG,
        IsMandAFlag
    }
}

const setIsApprovalOverrideFlag = (isApprovalOverrideFlag: boolean) => {
    return {
        type: SET_IS_APPROVAL_OVERRIDE_FLAG,
        isApprovalOverrideFlag
    }
}

const setProductionVehicleDangerouslySetExpanded = (productionVehicleDangerouslySetExpandedList: any)=>{
    return {
        type : SET_PRODUCTION_VEHICLE_DANGEROUSLY_SET_EXPANDED,
        productionVehicleDangerouslySetExpandedList: productionVehicleDangerouslySetExpandedList,
    }
}


const setOrderEditNavigateChange = (orderEditNavigateChange: any) => {
        return {
        type: SET_ORDER_EDIT_NAVIGATION_CHANGE,
        orderEditNavigateChange: orderEditNavigateChange,
    };
};

const setIsAddAssetclick = (isAddAssetclick: any) => {
    return {
        type: SET_IS_ADD_ASSET_CLICK,
        isAddAssetclick: isAddAssetclick,
    };
};

const setIsAddItemclick = (isAddItemclick: any) => {
    return {
        type: SET_IS_ADD_ITEM_CLICK,
        isAddItemclick: isAddItemclick,
    }
};

//Edit request Types
const setEditRequestDetails = (editRequestDetails: any) => {
    return {
    type: SET_EDIT_REQUEST_DETAILS,
    editRequestDetails: editRequestDetails,
};
};

const setIsEditRequestClick = (isEditRequestClick: any) => {
    return {
    type: SET_IS_EDIT_REQUEST_CLICK,
    isEditRequestClick: isEditRequestClick,
};
};

const setIsAddRequistionTypeClick = (isAddRequistionTypeClick: any) => {
    return {
    type: SET_IS_ADD_REQUISITION_TYPE_CLICK,
    isAddRequistionTypeClick: isAddRequistionTypeClick,
};
};

const setIsUpdateSuccessAlert = (isUpdateSuccessAlert: any) => {
    return {
    type: SET_IS_UPDATE_SUCCESS_ALERT,
    isUpdateSuccessAlert: isUpdateSuccessAlert,
};
};

const setIsDealerSameForAllFlagFlag = (isDealerSameForAllFlag: boolean) => {
    return {
        type: SET_IS_DEALER_SAMEFORALL_FLAG,
        isDealerSameForAllFlag
    }
}

export default {
    // setRequest,
    // setSelectedSubTypeId,
    setSelectedBranch,
    setSelectedRequisitionType,
    setIRequest,
    setIManagementVehicle,
    setINonStandardEquipment,
    setIProductionVehicle,
    setIReason,
    setCartIRequest,
    setCartIProductionVehicle,
    setCartINonStandardEquipment,
    setCartIManagementVehicle,
    setCartIReason,
    setShowItemDetails,
    setIsAddToCartClick,
    setIsReasonChange,
    setIOrderRequest,
    createOrderRequest,
    isSubmitClick,
    isSaveClick,
    setOrderLeadrNumber,
    setIsOrderCreationSuccess,
    setOrderId,
    setIsEditOrder,
    setIManagedEquipment,
    setCartIManagedEquipment,
    setManagedEquipmentValues,
    setSelectedEquipmentType,
    setSelectedCatalogItem,
    setIsCatalogItemExist,
    setIsChangesOccured,
    setIsMandFlag,
    setProductionVehicleDangerouslySetExpanded,
    setOrderEditNavigateChange,
    setIsAddAssetclick,
    setIsAddItemclick,
    setEditRequestDetails,
    setIsEditRequestClick,
    setIsAddRequistionTypeClick,
    setIsUpdateSuccessAlert,
    setIsApprovalOverrideFlag,
    setIsDealerSameForAllFlagFlag
};
